const engagementTrackingAction = 'product rec engagement';
$(document).ready(function() {
    $(window).on('carouselChange', function (e) {
        handleCarouselEngagement(e);
    });
    $(window).on('beforeunload', function() {
        endEngagement();
    });
    $(document).on('click', 'a.product-recs__link', function () {
        const activeCarousel = $(this).closest("section.product-recs");
        if (activeCarousel.hasClass("eng-tracking-on")) {
            activeCarousel.removeClass('eng-tracking-on');
            const data = {
                leftclick: activeCarousel.data("eng-left-click"),
                rightclick: activeCarousel.data("eng-right-click"),
                slideclick: $(this).data('slide-index') + 1,
            }
            logEngagementWithDetails(window.location.href, activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
            activeCarousel.unbind('touchend');
        } else {
            activeCarousel.find('a.product-recs__link').each(function(index){
                $(this).data('slide-index', index);
            });

            if($('section.eng-tracking-on').length){ // slide clicked of the carousal which was not currently being tracked, so end tracking of the tracked carousal first.
                endEngagement();
            }
            const type = $($(this).closest('div[data-type]')).attr('data-type');
            const data = {
                leftclick: 0,
                rightclick: 0,
                slideclick: $(this).data('slide-index') + 1,
            }
            logEngagementWithDetails(window.location.href, type, engagementTrackingAction, JSON.stringify(data));
        }
        clearTimeout(window.carouselEngagementTracker);
        window.carouselEngagementTracker = null;
     });
});
function endEngagement() {
    const activeCarousel = $('section.eng-tracking-on');
    clearTimeout(window.carouselEngagementTracker);
    window.carouselEngagementTracker = null;
    if (activeCarousel.length) {
        activeCarousel.removeClass('eng-tracking-on');
        var data = {
            leftclick: activeCarousel.data('eng-left-click'),
            rightclick: activeCarousel.data('eng-right-click'),
        }
        activeCarousel.unbind('touchend');
        logEngagementWithDetails(activeCarousel.data("pageUrl"), activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
    }
}
function handleCarouselEngagement(e) {
    let startEngagement = function () {
        let activeCarousel = $(e.originalEvent.tracking.element).closest("section.product-recs");
        activeCarousel.addClass("eng-tracking-on");
        activeCarousel.data("pageUrl", e.originalEvent.tracking.pageUrl);
        activeCarousel.data("type", e.originalEvent.tracking.type);
        activeCarousel.data("eng-left-click", 0);
        activeCarousel.data("eng-right-click", 1);
        activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);

        activeCarousel.find('a.product-recs__link').each(function(index){
            $(this).data('slide-index', index);
        });
};
    let resetEngagement = function(){
        endEngagement();
        startEngagement();
    };
    let continueEngagement = function(){
        const activeCarousel = $('section.eng-tracking-on');
        clearTimeout(window.carouselEngagementTracker);
        window.carouselEngagementTracker = null;
        const lastSlide = activeCarousel.data("currentSlide");
        if(lastSlide < e.originalEvent.tracking.currentSlide) {
            const rightClickCount = activeCarousel.data('eng-right-click');
            activeCarousel.data('eng-right-click', rightClickCount + 1);
        } else {
            const leftClickCount = activeCarousel.data('eng-left-click');
            activeCarousel.data('eng-left-click', leftClickCount + 1);
        }
        activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
        window.carouselEngagementTracker = setTimeout(function () {
            endEngagement();
        }, 5000);
    };


    if($('section.eng-tracking-on').length) {
        const activeCarousel = $(e.originalEvent.tracking.element).closest('section.product-recs');
        if(activeCarousel.hasClass('eng-tracking-on')){
            continueEngagement();
        } else {
            resetEngagement();
        }
    } else {
        startEngagement();
    }
}


// WEBPACK FOOTER //
// ./src/scripts/modules/product-rec-tracking.js